/* 無料カード診断 v4。多軸スコアで相性の近いデッキを返す。データは assets/luna-diagnosis-data.json */
(function () {
  var D = null, ANS = {}, QI = 0, ROOT, QS = [], TIMER = null;
  var ORDER = ['look', 'color', 'theme', 'use', 'read', 'volume'];
  var W = { look: 3, read: 3, volume: 2, theme: 2, color: 2, use: 2 };
  var MAXS = 14;
  var LS_KEY = 'lf-dx-last';
  var REDUCED = false, MAN = '', MAN2 = '', BACKS = {}, CAT = '';
  try { REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* 選択肢に見せる実カード（handle） */
  var REPS = {
    look: {
      cute: ['dreamingcattarot', 'pomeranianmochitarot', 'happylove'],
      mystic: ['kanaeryuoracle', 'lunaslightangeltarot', 'lepetitprince'],
      cool: ['lunasgothictarot', 'ikementarot', 'lunasdarkangeltarot'],
      japan: ['taisho-roman-tarot', 'japaneseshinwaoracle', 'enmusubikyotooracle']
    },
    color: {
      pale: ['dreamingcattarot', 'lunascinnamorolltarot', 'pastelunicorntarot'],
      vivid: ['lunasyume100tarot', 'kuromitarot', 'retropoptarot'],
      mono: ['lunasgothictarot', 'lunasdarkangeltarot', 'the-bushido-oracle']
    }
  };
  var HERO = ['taisho-roman-tarot', 'kanaeryuoracle', 'dreamingcattarot', 'kuromitarot', 'lunasgothictarot'];

  var ICON = {
    love: '<path d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.5A4 4 0 0 1 19 10c0 5.5-7 10-7 10z"/>',
    work: '<circle cx="12" cy="12" r="9"/><path d="M15 9l-2 5-4 2 2-5z"/>',
    heal: '<path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z"/>',
    self: '<ellipse cx="12" cy="9" rx="6" ry="7"/><path d="M12 16v5M9 21h6"/>',
    others: '<circle cx="9" cy="8" r="3"/><circle cx="16.5" cy="9" r="2.5"/><path d="M3 20a6 6 0 0 1 12 0M14 20a4 4 0 0 1 7-2.5"/>',
    daily: '<circle cx="12" cy="12" r="4"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M4.9 19.1L7 17M17 7l2.1-2.1"/>',
    guided: '<path d="M3 5h6a3 3 0 0 1 3 3v12a3 3 0 0 0-3-3H3zM21 5h-6a3 3 0 0 0-3 3v12a3 3 0 0 1 3-3h6z"/>',
    intuitive: '<path d="M2 12s4-6 10-6 10 6 10 6-4 6-10 6-10-6-10-6z"/><circle cx="12" cy="12" r="3"/>',
    many: '<rect x="4" y="6" width="11" height="15" rx="2"/><path d="M9 3h9a2 2 0 0 1 2 2v13"/>',
    few: '<rect x="7" y="3" width="10" height="18" rx="2"/><path d="M10 8h4"/>',
    any: '<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z"/>'
  };

  var TYPE = {
    cute: { self: 'ふわふわ内省タイプ', others: 'ほっこり寄り添いタイプ', daily: 'まいにちごほうびタイプ' },
    mystic: { self: '星読み内省タイプ', others: '月夜の語り部タイプ', daily: 'まいにち祈りタイプ' },
    cool: { self: '静かな探究タイプ', others: '凛とした助言タイプ', daily: 'まいにち決断タイプ' },
    japan: { self: '和の余白タイプ', others: '縁むすび相談タイプ', daily: 'まいにち和みタイプ' }
  };
  var AXIS = [['look', '絵の雰囲気'], ['color', '色'], ['theme', 'テーマ'], ['use', '使い方'], ['read', '読み方'], ['volume', '枚数']];
  var LOOKW = { cute: 'かわいい', mystic: '幻想的な', cool: 'かっこいい', japan: '和・レトロな' };
  var COLORW = { pale: '淡い', vivid: '鮮やかな', mono: 'シックな' };
  var THEMEW = { love: '恋愛や人との縁', work: '仕事やこれからのこと', heal: '自分の心' };
  var USEW = { self: '自分の気持ちを整理するの', others: '人を占ってあげるの', daily: '毎日一枚引くの' };

  function el(t, c, x) { var e = document.createElement(t); if (c) e.className = c; if (x != null) e.textContent = x; return e; }
  function svg(k) { var s = el('span', 'lfdx-ico'); s.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICON[k] || '') + '</svg>'; return s; }
  function hash(s) { var h = 5381, i; for (i = 0; i < s.length; i++) { h = ((h << 5) + h + s.charCodeAt(i)) >>> 0; } return h / 4294967295; }
  function byH(h) { var i; for (i = 0; i < D.decks.length; i++) if (D.decks[i].h === h) return D.decks[i]; return null; }
  function src(d, w) { return d.img + (d.img.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function img(d, w, lazy) { var i = new Image(); i.src = src(d, w); i.alt = ''; if (lazy) i.loading = 'lazy'; i.decoding = 'async'; return i; }
  function preload() { Object.keys(BACKS).forEach(function (k) { new Image().src = BACKS[k]; }); var seen = {}; Object.keys(REPS).forEach(function (q) { Object.keys(REPS[q]).forEach(function (v) { REPS[q][v].forEach(function (h) { var d = byH(h); if (d && !seen[h]) { seen[h] = 1; new Image().src = src(d, 240); } }); }); }); }
  function key() { return ORDER.map(function (id) { return ANS[id]; }).join('-'); }
  function parseKey(s) {
    if (!s) return null;
    var p = s.split('-'), out = {}, i;
    if (p.length !== ORDER.length) return null;
    for (i = 0; i < ORDER.length; i++) {
      var q = QS.filter(function (x) { return x.id === ORDER[i]; })[0];
      if (!q || !q.options.some(function (o) { return o.v === p[i]; })) return null;
      out[ORDER[i]] = p[i];
    }
    return out;
  }
  function setUrl(k) {
    try {
      var u = new URL(location.href);
      if (k) u.searchParams.set('r', k); else u.searchParams.delete('r');
      history.replaceState(null, '', u.toString());
    } catch (e) {}
  }
  function store(k) { try { localStorage.setItem(LS_KEY, JSON.stringify({ k: k, t: Date.now() })); } catch (e) {} }
  function loadStore() { try { return JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) { return null; } }

  /* ---------- 判定 ---------- */
  function score(d, a) {
    var s = 0, why = [], hit = {};
    if (d.look.indexOf(a.look) > -1) { s += W.look; why.push(a.look); hit.look = 1; }
    if ((a.read === 'guided') === !!d.guided) { s += W.read; hit.read = 1; if (a.read === 'guided') why.push('guided'); }
    if (a.volume === 'any' || d.vol === 'unknown') { s += 1; hit.volume = a.volume === 'any' ? 1 : 0; }
    else if (a.volume === d.vol) { s += W.volume; why.push(d.vol); hit.volume = 1; }
    else if (d.vol === 'mid') { s += 1; }
    if (d.theme.indexOf(a.theme) > -1) { s += W.theme; why.push(a.theme); hit.theme = 1; }
    if (a.color === d.color) { s += W.color; why.push(a.color); hit.color = 1; }
    if (d.use.indexOf(a.use) > -1) { s += W.use; why.push(a.use); hit.use = 1; }
    return { s: s, why: why, hit: hit };
  }
  function rank(a, n) {
    var k = ORDER.map(function (id) { return a[id]; }).join('-'), out = [], seen = {}, kinds = 0, i;
    var sc = D.decks.map(function (d) {
      var r = score(d, a);
      return { k: r.s + hash(d.h + k) * 0.9, s: r.s, why: r.why, hit: r.hit, d: d };
    }).sort(function (x, y) { return y.k - x.k; });
    for (i = 0; i < sc.length && out.length < n; i++) {
      var t = sc[i].d.type;
      if (seen[t] && out.length > 0 && out.length < 3 && kinds < 3) continue;
      if (!seen[t]) { seen[t] = 1; kinds++; }
      out.push(sc[i]);
    }
    return out;
  }

  /* ---------- 画面 ---------- */
  function view(name) {
    [].forEach.call(ROOT.querySelectorAll('.lfdx-view'), function (v) { v.hidden = v.dataset.view !== name; });
    ROOT.dataset.view = name;
    var top = ROOT.getBoundingClientRect().top + window.scrollY - 72;
    if (window.scrollY > top) window.scrollTo({ top: top, behavior: REDUCED ? 'auto' : 'smooth' });
  }
  function focusH(h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }

  function renderTop() {
    var fan = ROOT.querySelector('#lfdx-fan');
    if (fan && !fan.children.length) {
      HERO.forEach(function (h, i) {
        var d = byH(h); if (!d) return;
        var c = el('span', 'lfdx-fancard'); c.style.setProperty('--i', i);
        c.appendChild(img(d, 300)); fan.appendChild(c);
      });
    }
    var tc = ROOT.querySelector('#lfdx-types');
    if (tc && !tc.children.length) {
      Object.keys(TYPE).forEach(function (l) { Object.keys(TYPE[l]).forEach(function (u) { tc.appendChild(el('span', 'lfdx-tchip', TYPE[l][u])); }); });
    }
    var prev = loadStore(), pv = ROOT.querySelector('#lfdx-prev');
    if (pv) {
      var a = prev && parseKey(prev.k);
      if (a) {
        var rs = rank(a, 1), dt = new Date(prev.t);
        pv.hidden = false;
        pv.textContent = '前回の結果（' + (dt.getMonth() + 1) + '月' + dt.getDate() + '日）：' + rs[0].d.n + ' を見る';
        pv.onclick = function (ev) { ev.preventDefault(); ANS = a; showResult(false); };
      } else pv.hidden = true;
    }
  }

  function optionTile(q, o) {
    var b = el('button', 'lfdx-opt'); b.type = 'button';
    var reps = REPS[q.id] && REPS[q.id][o.v];
    if (reps) {
      b.className += ' is-tile';
      var strip = el('span', 'lfdx-strip');
      reps.forEach(function (h) { var d = byH(h); if (d) strip.appendChild(img(d, 240)); });
      b.appendChild(strip);
      b.appendChild(el('span', 'lfdx-optlabel', o.label));
    } else {
      b.appendChild(svg(o.v));
      b.appendChild(el('span', 'lfdx-optlabel', o.label));
    }
    return b;
  }

  function renderQuestion() {
    var q = QS[QI], wrap = ROOT.querySelector('#lfdx-q');
    wrap.innerHTML = '';
    var card = el('div', 'lfdx-panel lfdx-qcard' + (REDUCED ? '' : ' lfdx-in'));
    if (CAT) { var qc = new Image(); qc.src = CAT; qc.alt = ''; qc.className = 'lfdx-qcat'; card.appendChild(qc); }
    var head = el('div', 'lfdx-qhead');
    var dots = el('div', 'lfdx-dots');
    QS.forEach(function (_, i) { dots.appendChild(el('span', 'lfdx-dot' + (i < QI ? ' is-done' : i === QI ? ' is-now' : ''))); });
    head.appendChild(dots);
    head.appendChild(el('p', 'lfdx-step', 'Q' + (QI + 1) + ' / ' + QS.length));
    card.appendChild(head);
    var h = el('h2', 'lfdx-qt', q.text); card.appendChild(h);
    var ul = el('div', 'lfdx-opts' + (REPS[q.id] ? ' is-tiles' : ''));
    q.options.forEach(function (o, i) {
      var b = optionTile(q, o);
      b.dataset.n = i + 1;
      b.addEventListener('click', function () { pick(q, o, b, ul); });
      ul.appendChild(b);
    });
    card.appendChild(ul);
    var nav = el('div', 'lfdx-qnav');
    if (QI > 0) {
      var back = el('button', 'lfdx-back', '一つ前に戻る'); back.type = 'button';
      back.addEventListener('click', function () { QI--; renderQuestion(); });
      nav.appendChild(back);
    }
    nav.appendChild(el('span', 'lfdx-hint', '数字キーでも選べます'));
    card.appendChild(nav);
    wrap.appendChild(card);
    view('q');
    focusH(h);
  }

  function pick(q, o, b, ul) {
    if (ul.classList.contains('is-locked')) return;
    ul.classList.add('is-locked'); b.classList.add('is-picked');
    ANS[q.id] = o.v;
    clearTimeout(TIMER);
    TIMER = setTimeout(function () {
      QI++;
      if (QI < QS.length) renderQuestion(); else showResult(true);
    }, REDUCED ? 0 : 280);
  }

  function showResult(withWait) {
    var k = key(); store(k); setUrl(k);
    if (withWait && !REDUCED) {
      var w = ROOT.querySelector('#lfdx-w'); w.innerHTML = '';
      w.appendChild(scene('あなたの答えから、​ぴったりの一組を​お探ししています', true));
      var deck = el('div', 'lfdx-shuffle');
      for (var i = 0; i < 3; i++) { var c = el('span', 'lfdx-cardback'); c.style.setProperty('--i', i); c.appendChild(backImg(ANS.look, i)); deck.appendChild(c); }
      w.appendChild(deck);
      w.appendChild(el('p', 'lfdx-wtext', D.decks.length + '組の中から、いちばん近い一組を選んでいます'));
      view('w');
      clearTimeout(TIMER);
      TIMER = setTimeout(function () { renderResult(false); }, 2000);
    } else renderResult(false);
  }

  function backSrc(look, i) {
    var order = { cute: ['cute', 'cute2', 'mystic'], mystic: ['mystic', 'cute2', 'cute'], cool: ['cool', 'japan', 'mystic'], japan: ['japan', 'cool', 'cute'] };
    var ks = order[look] || order.cute;
    return BACKS[ks[i || 0]] || BACKS.cute || '';
  }
  function backImg(look, i) { var im = new Image(); im.src = backSrc(look, i); im.alt = ''; im.decoding = 'async'; return im; }
  function scene(text, alt) {
    var sc = el('div', 'lfdx-scene');
    var bl = el('p', 'lfdx-balloon', text); sc.appendChild(bl);
    var src = (alt && MAN2) || MAN;
    if (src) { var m = new Image(); m.src = src; m.alt = ''; m.className = 'lfdx-man'; sc.appendChild(m); }
    return sc;
  }
  function chip(v) { var t = D.axisLabel[v]; return t ? el('span', 'lfdx-chip', t) : null; }

  function blurb(r) {
    var d = r.d, s = '';
    s += d.look.map(function (l) { return LOOKW[l]; }).join('・') + '絵柄と、' + COLORW[d.color] + '色あい。';
    s += d.theme.map(function (t) { return THEMEW[t]; }).join('や') + 'を見つめたいときに寄り添ってくれる一組で、';
    s += d.use.map(function (u) { return USEW[u]; }).join('にも、') + 'に向いています。';
    if (d.guided) s += 'カードに意味が書いてあるので、はじめてでも読みやすいです。';
    return s;
  }

  function deckCard(r, kind) {
    var d = r.d, a = el('a', 'lfdx-deck is-' + kind);
    a.href = '/products/' + d.h;
    var im = el('span', 'lfdx-deckimg');
    if (kind === 'main') {
      var flip = el('span', 'lfdx-flip');
      var fb = el('span', 'lfdx-face lfdx-faceback'); fb.appendChild(backImg(ANS.look, 0)); flip.appendChild(fb);
      var f = el('span', 'lfdx-face lfdx-facefront'); f.appendChild(img(d, 900)); flip.appendChild(f);
      im.appendChild(flip);
      setTimeout(function () { flip.classList.add('is-on'); }, REDUCED ? 0 : 500);
    } else im.appendChild(img(d, 480, true));
    a.appendChild(im);
    var b = el('span', 'lfdx-deckbody');
    b.appendChild(el('span', 'lfdx-deckkind', d.type + (d.cards ? '／' + d.cards + '枚' : '')));
    b.appendChild(el('span', 'lfdx-deckname', d.n));
    if (kind === 'main') {
      var ch = el('span', 'lfdx-chips');
      r.why.forEach(function (w) { var c = chip(w); if (c) ch.appendChild(c); });
      b.appendChild(ch);
    } else {
      b.appendChild(el('span', 'lfdx-deckwhy', r.why.slice(0, 3).map(function (w) { return D.axisLabel[w]; }).filter(Boolean).join('・')));
    }
    var pr = el('span', 'lfdx-deckprice', '¥' + d.p.toLocaleString());
    pr.appendChild(el('small', null, '（税込）'));
    b.appendChild(pr);
    b.appendChild(el('span', 'lfdx-deckgo', '商品ページを見る'));
    a.appendChild(b);
    return a;
  }

  function axisRow(r) {
    var row = el('div', 'lfdx-axes'), n = 0;
    AXIS.forEach(function (ax) {
      var hit = !!r.hit[ax[0]]; if (hit) n++;
      var c = el('span', 'lfdx-ax' + (hit ? ' is-hit' : ''), ax[1]);
      c.title = hit ? '一致' : '一致せず';
      row.appendChild(c);
    });
    var lab = el('span', 'lfdx-axn', '一致 ' + n + '／' + AXIS.length);
    row.insertBefore(lab, row.firstChild);
    return row;
  }

  function shareBtn(cls, text, href) {
    var a = el('a', 'lfdx-share ' + cls, text); a.href = href; a.target = '_blank'; a.rel = 'noopener noreferrer nofollow'; return a;
  }

  function renderResult(fromLink) {
    var rs = rank(ANS, 6), wrap = ROOT.querySelector('#lfdx-r');
    var type = (TYPE[ANS.look] || {})[ANS.use] || '';
    wrap.innerHTML = '';
    var sc = scene(fromLink ? 'こちらが、​おともだちに​お迎えしてほしいと​望んでいる​カードたちです' : 'お待たせしました。​こちらが、​あなたに​お迎えしてほしいと​望んでいる​カードたちです');
    sc.className += ' lfdx-rscene' + (REDUCED ? '' : ' lfdx-in');
    wrap.appendChild(sc);
    var card = el('div', 'lfdx-panel lfdx-rcard' + (REDUCED ? '' : ' lfdx-in'));
    if (fromLink) card.appendChild(el('p', 'lfdx-linknote', '共有された診断結果を表示しています'));
    var rh = el('div', 'lfdx-rhead');
    rh.appendChild(el('p', 'lfdx-kicker', 'あなたのタイプ'));
    var h = el('h2', 'lfdx-rt', type || 'あなたに近い一組');
    rh.appendChild(h); card.appendChild(rh);
    card.appendChild(el('p', 'lfdx-rlead', D.decks.length + '組の中で、あなたのそばに行きたいと、いちばん強く手を挙げた一組です。'));
    card.appendChild(deckCard(rs[0], 'main'));
    card.appendChild(axisRow(rs[0]));
    card.appendChild(el('p', 'lfdx-blurb', blurb(rs[0])));

    if (rs.length > 1) {
      card.appendChild(el('h3', 'lfdx-sub', 'こちらも、あなたに似合いそう'));
      var g = el('div', 'lfdx-grid');
      rs.slice(1, 3).forEach(function (r) { g.appendChild(deckCard(r, 'sub')); });
      card.appendChild(g);
      if (rs.length > 3) {
        var extra = rs.slice(3).map(function (r) { var c = deckCard(r, 'sub'); c.hidden = true; g.appendChild(c); return c; });
        var mb = el('button', 'lfdx-morebtn', 'ほかの候補も' + extra.length + '組見る'); mb.type = 'button';
        mb.addEventListener('click', function () { extra.forEach(function (c) { c.hidden = false; }); mb.hidden = true; });
        card.appendChild(mb);
      }
    }

    var cta = el('div', 'lfdx-cta');
    cta.appendChild(el('p', 'lfdx-ctat', 'それでも迷うときは'));
    cta.appendChild(el('p', 'lfdx-ctab', 'プロのカードリーダーが、お悩みをうかがってあなたに合う一組を選びます。5,500円・送料込み／約10日でお届け。'));
    var ca = el('a', 'lfdx-ctalink', '占いカード選書サービスを見る'); ca.href = '/products/reccomendbook';
    cta.appendChild(ca);
    card.appendChild(cta);

    var browse = el('p', 'lfdx-browse');
    var b1 = el('a', null, 'タロットをすべて見る'); b1.href = '/collections/tarotdacks';
    var b2 = el('a', null, 'オラクルをすべて見る'); b2.href = '/collections/oraclecarddecks';
    browse.appendChild(b1); browse.appendChild(b2);
    card.appendChild(browse);

    var act = el('div', 'lfdx-actions');
    var url = location.origin + location.pathname + '?r=' + encodeURIComponent(key());
    var txt = '無料カード診断で、私は「' + type + '」。近い一組は「' + rs[0].d.n + '」でした。 #ルナファクトリー #カード診断';
    act.appendChild(shareBtn('is-x', 'Xで共有', 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(txt)));
    act.appendChild(shareBtn('is-line', 'LINEで送る', 'https://social-plugins.line.me/lineit/share?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(txt)));
    var cp = el('button', 'lfdx-copy', 'リンクをコピー'); cp.type = 'button';
    cp.addEventListener('click', function () {
      var done = function () { cp.textContent = 'コピーしました'; setTimeout(function () { cp.textContent = 'リンクをコピー'; }, 1800); };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () { prompt('このリンクをコピーしてください', url); });
      else prompt('このリンクをコピーしてください', url);
    });
    act.appendChild(cp);
    card.appendChild(act);

    var again = el('button', 'lfdx-again', fromLink ? 'わたしも診断してみる' : 'もう一度診断する'); again.type = 'button';
    again.addEventListener('click', function () { ANS = {}; QI = 0; setUrl(null); renderQuestion(); });
    card.appendChild(again);

    wrap.appendChild(card);
    view('r');
    focusH(h);
  }

  function onKey(ev) {
    if (ROOT.dataset.view !== 'q') return;
    var n = parseInt(ev.key, 10); if (!n) return;
    var b = ROOT.querySelector('#lfdx-q .lfdx-opt[data-n="' + n + '"]');
    if (b) b.click();
  }

  function init() {
    ROOT = document.getElementById('lfdx');
    if (!ROOT) return;
    MAN = ROOT.dataset.man || ''; MAN2 = ROOT.dataset.man2 || '';
    try { BACKS = JSON.parse(ROOT.dataset.backs || '{}'); } catch (e) { BACKS = {}; }
    var c2 = ROOT.querySelector('.lfdx-cat2'); CAT = c2 ? c2.getAttribute('src') : '';
    fetch(ROOT.dataset.src).then(function (r) { return r.json(); }).then(function (j) {
      D = j;
      QS = ORDER.map(function (id) { return D.questions.filter(function (q) { return q.id === id; })[0]; }).filter(Boolean);
      var cnt = ROOT.querySelector('#lfdx-count');
      if (cnt) cnt.textContent = D.decks.length;
      var st = ROOT.querySelector('#lfdx-start');
      st.addEventListener('click', function () { ANS = {}; QI = 0; renderQuestion(); });
      st.disabled = false;
      document.addEventListener('keydown', onKey);
      renderTop();
      preload();
      var r = null;
      try { r = new URL(location.href).searchParams.get('r'); } catch (e) {}
      var a = parseKey(r);
      if (a) { ANS = a; renderResult(true); }
    }).catch(function () {
      ROOT.querySelector('#lfdx-err').hidden = false;
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
